import { useState } from 'react'
import { useAuth } from '../AuthProvider'
import { createLogger } from '../../utils/logger'
import { GoogleIcon, MicrosoftIcon } from './OAuthIcons'

const logger = createLogger('auth')

const OAUTH_PROVIDERS = [
  { id: 'google', label: 'Google', Icon: GoogleIcon },
  { id: 'azure', label: 'Microsoft', Icon: MicrosoftIcon },
]

const oauthButtonClass =
  'flex w-full items-center gap-3 rounded-md border border-neutral-300 bg-white px-4 py-2.5 text-sm font-medium text-neutral-900 shadow-sm transition-colors hover:bg-neutral-50 disabled:cursor-not-allowed disabled:opacity-70'

export default function OAuthButtons({ mode = 'signin', disabled = false, onError }) {
  const { signInWithOAuth } = useAuth()
  const [loadingProvider, setLoadingProvider] = useState(null)
  const actionLabel = mode === 'signup' ? 'Sign up' : 'Sign in'

  const handleOAuth = async (provider) => {
    onError?.('')
    setLoadingProvider(provider)
    const { error } = await signInWithOAuth(provider)
    if (error) {
      logger.warn('OAuth sign-in failed', { view: mode === 'signup' ? 'signup' : 'login', auth_method: provider })
      onError?.(error.message)
      setLoadingProvider(null)
    }
  }

  return (
    <div className="space-y-3">
      {OAUTH_PROVIDERS.map(({ id, label, Icon }) => (
        <button
          key={id}
          type="button"
          disabled={disabled || loadingProvider !== null}
          onClick={() => handleOAuth(id)}
          className={oauthButtonClass}
        >
          <Icon className="h-5 w-5 shrink-0" />
          <span className="flex-1 text-center pr-5">
            {loadingProvider === id ? (
              <span className="inline-block h-5 w-5 animate-spin rounded-full border-2 border-neutral-300 border-t-neutral-900" />
            ) : (
              `${actionLabel} with ${label}`
            )}
          </span>
        </button>
      ))}
    </div>
  )
}

export function EmailDivider({ mode = 'signin' }) {
  const label = mode === 'signup' ? 'or sign up with email' : 'or sign in with email'

  return (
    <div className="relative my-6">
      <div className="absolute inset-0 flex items-center" aria-hidden="true">
        <div className="w-full border-t border-neutral-200" />
      </div>
      <div className="relative flex justify-center">
        <span className="bg-white px-2 text-xs uppercase tracking-wide text-neutral-500">{label}</span>
      </div>
    </div>
  )
}
